<template>
  <div class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-5">
    <b-modal id="photoShareModal" title="Share" centered hide-footer>
      <div class="d-flex justify-content-around mb-8">
        <a
          rel="nofollow"
          :href="`https://facebook.com/share.php?u=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/facebook.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://linkedin.com/sharing/share-offsite/?url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Linkedin.svg"
          />
        </a>
        <a :href="`mailto:?body=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Mail.svg"
            alt=""
          />
        </a>
        <a :href="`https://api.whatsapp.com/send?text=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Whatsapp.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://twitter.com/share?text=google&url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Twitter.svg"
            alt=""
          />
        </a>
      </div>

      <!-- <div class="container" ref="modalBody">
        <input type="text" v-model="message" />
        <button type="button" @click="doCopy(message)">Copy!</button>
      </div> -->
      <b-input-group size="md" class="mb-2">
        <b-form-input
          type="text"
          :class="{ inputstyle: applystyle }"
          v-model="copy"
        ></b-form-input>
        <b-input-group-prepend
          ref="photoShareModalBody"
          type="button"
          is-text
          class="cursor-pointer textstyle"
          @click="doCopy(copy)"
        >
          COPY
        </b-input-group-prepend>
      </b-input-group>
    </b-modal>
    <template
      v-if="shareWork && shareWork.result && shareWork.result.length > 0"
    >
      <div
        class="bg-white shadow-lg rounded"
        v-for="(item, index) in shareWork.result"
        :key="`${item}+${index}`"
      >
        <div class="flex justify-between relative">
          <img
            v-if="item.images.length !== 0 && item.images[0]"
            :src="$imageURL + '/' + item.images"
            alt=""
            class="w-full h-96 object-contain"
          />
          <div class="absolute right-3 top-3">
            <img
              v-b-modal.photoShareModal
              @click="setLink(url)"
              src="../../../../assets/images/share.png"
              alt="ShareIcon"
              class="h-5 w-5 cursor-pointer"
            />
          </div>
        </div>
        <div class="flex justify-between px-2 mt-4">
          <div class="">
            <!-- <img
            :src="$imageURL + '/' + item.images[1]"
            alt=""
            class="w-8 h-8 rounded-full"
          /> -->
            <!-- <img
            v-if="item.createdByUser.length"
            :src="item.createdByUser[0].userImage"
            class="w-8 h-8 rounded-full"
          />
          <img
            v-else
            src="@/views/userProfile/UserProfile/av1.jpg"
            class="w-8 h-8 rounded-full"
          /> -->
            <div>
              <h2>{{ item.firstName + " " + (item.lastName || "") }}</h2>
              <div class="fsize12" v-html="item.message">
                <!-- {{ item.message.replace(/<\/?[^>]+>/gi, "") }} -->
                <!-- <div v-html="item.message"></div> -->
              </div>
            </div>
          </div>
          <div class="bg-primary px-5 h-30px rounded-full">
            <div
              class="flex gap-2 items-center cursor-pointer"
              @click="updateLike(item._id)"
            >
              <div>
                <b-icon
                  v-if="renderlike(item.likedBy)"
                  icon="hand-thumbs-up-fill"
                  font-scale="1.2"
                  class="text-white"
                />
                <b-icon
                  v-else
                  icon="hand-thumbs-up"
                  font-scale="1.2"
                  class="text-white"
                />
              </div>
              <p class="text-white">
                {{ item.likeCount ? item.likeCount : 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex items-center gap-2 justify-center">
        <p class="text-center">No Photos Available</p>
      </div>
    </template>
  </div>
</template>

<script>
import { BIcon, BIconHandThumbsUpFill, BIconHandThumbsUp } from "bootstrap-vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      photos: [
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
      ],
      copy: "",
      applystyle: false,
    };
  },
  components: {
    BIcon,
    BIconHandThumbsUpFill,
    BIconHandThumbsUp,
  },
  methods: {
    setLink(link) {
      this.copy = link;
    },

    doCopy(copy) {
      this.$copyText(copy, this.$refs.photoShareModalBody);
      this.applystyle = true;
      // swal.fire({ title: "", icons: "success" });
      this.$swal.fire({
        text: "Link copied to clipboard",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
    },
    handleRedirect(name) {
      this.$router.push({ name: name });
      this.$swal.fire({
        title: "",
        text: "Please login to access this content",
        icon: "warning",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
    },
    isLogedIn() {
      if (sessionStorage.getItem("token")) {
        return true;
      } else {
        this.handleRedirect("signin");
        return false;
      }
    },
    renderlike(likedBy) {
      if (likedBy && this.user._id) {
        if (likedBy.includes(this.user._id)) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    async updateLike(shareWorkId) {
      if (!this.isLogedIn()) {
        return;
      }

      let payload = {
        shareWorkId: shareWorkId,
      };
      try {
        let data = await this.$store.dispatch("hoc/setLike", payload);
        if (data.code === 200) {
          await this.getPhotos();
        }
        // if (data.code === 401) {
        //   this.handleRedirect("signin");
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async getPhotos() {
      let payload = {
        art: "Photo",
        limit: 100,
        offset: 0,
        status: "Approved",
      };
      try {
        await this.$store.dispatch("hoc/getSharework", payload);
      } catch (error) {
        console.log(error);
      }
    },
  },

  computed: {
    ...mapState("hoc", { shareWork: "shareWork" }),
    ...mapState("auth", { user: "user" }),
    url() {
      return window.location.href;
    },
  },

  async mounted() {
    await this.getPhotos();
    // console.log(this.shareWork);
  },
};
</script>

<style></style>
